"use client";

import { Card, Col, Row, Typography } from "antd";
import { useEffect } from "react";
import Head from "next/head";
import PDFViewer from "@/components/common/PDFViewer";
import MKTScript from "@/components/MKTScript";
import { useTranslation } from "react-i18next";

const { Title } = Typography;

const PurchaseGuidePage = () => {
  const { i18n } = useTranslation()
  // Scroll to top when page loads
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <MKTScript />
      <Head>
        <title>Hướng dẫn mua hàng | {process.env.NEXT_PUBLIC_PLATFORM_NAME || ""}</title>
        <meta
          name="description"
          content={`Hướng dẫn mua hàng trên ${process.env.NEXT_PUBLIC_PLATFORM_NAME || ""}`}
        />
      </Head>
      <div className="purchase-guide-container">
        <Row justify="center" style={{ padding: "20px" }}>
          <Col span={24}>
            <PDFViewer
              file={`/static/docs/${i18n.language === 'vi' ? "HUONG_DAN_MUA_HANG_VI" : "HUONG_DAN_MUA_HANG_EN"}.pdf`}
              title="Hướng dẫn mua hàng chi tiết"
              width={800}
              showControls={true}
              showDownload={true}
              className="purchase-guide-pdf"
            />
          </Col>
        </Row>
      </div>

      <style jsx global>{`
        .purchase-guide-container {
          background-color: #f5f5f5;
          min-height: 100vh;
          padding: 2rem 0;
        }

        .purchase-guide-pdf {
          width: 100%;
          max-width: 100%;
        }

        @media (max-width: 768px) {
          .purchase-guide-container {
            padding: 1rem 0;
          }
          
          .purchase-guide-pdf {
            width: 100%;
          }
        }
      `}</style>
    </>
  );
};

export default PurchaseGuidePage;